var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dataListLoading,
              expression: "dataListLoading",
            },
          ],
          ref: "dataTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.dataList,
            border: "",
            stripe: "",
            "header-cell-style": this.$globalGrayTableHeaderStyle,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              label: "序号",
              width: "50",
              fixed: "",
              index: _vm.getRowsIndex,
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "bidCode",
              "show-overflow-tooltip": "",
              label: "标段编号",
              align: "center",
              fixed: "",
              width: "210",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "bidName",
              "show-overflow-tooltip": "",
              label: "标段名称",
              "header-align": "left",
              align: "left",
              fixed: "",
              width: "400",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "bidOpenTime",
              "show-overflow-tooltip": true,
              label: "开标时间",
              align: "center",
              width: "200",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "superviseDeptName",
              "show-overflow-tooltip": true,
              label: "监督部门",
              align: "left",
              width: "200",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "bidopenSuperviseManName",
              "show-overflow-tooltip": "",
              label: "开标监督人",
              align: "center",
              width: "150",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "bidopenSuperviseTime",
              "show-overflow-tooltip": "",
              label: "开标监督记录提交时间",
              align: "center",
              width: "170",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          scope.row.bidOpeningHistory == 2
                            ? scope.row.bidopenSuperviseTime
                            : ""
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "evalSuperviseManName",
              label: "评标监督人",
              align: "center",
              width: "150",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "evalSuperviseTime",
              label: "评标监督记录提交时间",
              align: "center",
              width: "170",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          scope.row.evalHistory == 2
                            ? scope.row.evalSuperviseTime
                            : ""
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "bidOpeningHistory",
              label: "开标监督记录",
              width: "120",
              align: "center",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.bidOpeningHistory == 1
                      ? _c("span", { staticClass: "triangle" })
                      : _vm._e(),
                    scope.row.bidOpeningHistory != 0
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.showOpenDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "evalHistory",
              width: "120",
              fixed: "right",
              align: "center",
              label: "评标监督记录",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.evalHistory == 1
                      ? _c("span", { staticClass: "triangle" })
                      : _vm._e(),
                    scope.row.evalHistory != 0
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.showDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看 ")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.pageIndex,
          "page-sizes": [10, 20, 50, 100],
          "page-size": _vm.pageSize,
          total: _vm.totalPage,
          layout: "total, sizes, prev, pager, next, jumper",
        },
        on: {
          "size-change": _vm.sizeChangeHandle,
          "current-change": _vm.currentChangeHandle,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }